import React from 'react';
import PropTypes from 'prop-types';
import StorefrontListItem from './list-item';

import './storefront.scss';

export default class StorefrontNewAppRelatedThemes extends React.PureComponent {
  static propTypes = {
    app: PropTypes.object.isRequired,
    themes: PropTypes.array.isRequired,
    onViewApp: PropTypes.func.isRequired,
  };

  render() {
    const { themes, app, ...props } = this.props;

    return (
      <>
        <h2>{app.type === 'theme' ? 'Related themes' : 'Available themes'}</h2>
        <div className="storefront-apps-related storefront-apps-list">
          {themes.map((theme, index) => (
            <StorefrontListItem
              {...props}
              key={index}
              app={theme}
              isActionCard={false}
            />
          ))}
        </div>
      </>
    );
  }
}
